import { atom } from "recoil"

import { City } from "types/city.data"

export const citiesAtom = atom<City[]>({
  default: [],
  key: "citiesAtom",
})
